// extracted by mini-css-extract-plugin
module.exports = {"A":"A-module--A--3dqDA"};